import { FC, lazy, Suspense } from 'react'
import { Route, Routes, useSearchParams } from 'react-router'
import { LCAccessibilityWidget } from '../ui/components/lc-accessibility-widget/LCAccessibilityWidget'
import { LCRouteLoader } from '../ui/components/lc-route-loader/LCRouteLoader'
import { ePublicRoutes } from './e-routes'

// Lazy load all public route components
const Login = lazy(() => import('../pages/auth/login/Login').then((m) => ({ default: m.Login })))
const Page404 = lazy(() => import('../pages/auth/page-404/Page404').then((m) => ({ default: m.Page404 })))
const ResetPassword = lazy(() => import('../pages/auth/resetPassword/ResetPassword').then((m) => ({ default: m.ResetPassword })))
const SetNewPassword = lazy(() => import('../pages/auth/setNewPassword/SetNewPassword').then((m) => ({ default: m.SetNewPassword })))
const VerifyEmail = lazy(() => import('../pages/auth/verifyEmail/VerifyEmail').then((m) => ({ default: m.VerifyEmail })))
const RegisterCompanyEmailPage = lazy(() =>
  import('../pages/auth/registerNewCompany/emailPage/RegisterCompanyEmailPage').then((m) => ({ default: m.RegisterCompanyEmailPage }))
)
const RegisterCompanyDetailsPage = lazy(() =>
  import('../pages/auth/registerNewCompany/companyDetailsPage/RegisterCompanyDetailsPage').then((m) => ({
    default: m.RegisterCompanyDetailsPage,
  }))
)
const AccessibilityPage = lazy(() => import('../pages/accessibility/AccessibilityPage').then((m) => ({ default: m.AccessibilityPage })))
const PublicStatusPage = lazy(() => import('../pages/status/PublicStatusPage').then((m) => ({ default: m.PublicStatusPage })))
const LoginMfa = lazy(() => import('../pages/auth/loginMFa/LoginMfa').then((m) => ({ default: m.LoginMfa })))
const ChangeExpiredPassword = lazy(() =>
  import('../pages/auth/ChangeExpiredPassword/change-expired-password').then((m) => ({ default: m.ChangeExpiredPassword }))
)
const SsoCallback = lazy(() => import('../pages/auth/ssoCallback/SsoCallback').then((m) => ({ default: m.SsoCallback })))
const RemoteSupportEstablish = lazy(() =>
  import('../pages/auth/remoteSupportEstablish/RemoteSupportEstablish').then((m) => ({ default: m.RemoteSupportEstablish }))
)
// @lat: [[routing#Public routes]]
export const PublicRoutes: FC = () => {
  const [searchParams] = useSearchParams()
  const keyModule = { keyModule: searchParams.get('keyModule') }
  const stepsIndex = { stepIndex: searchParams.get('stepIndex') }
  localStorage.setItem('stepIndexChatBot', JSON.stringify(stepsIndex))
  localStorage.setItem('keyModuleIsChatBot', JSON.stringify(keyModule))

  return (
    <div className="main-wrapper">
      <LCAccessibilityWidget customStyle={{ position: 'absolute', top: '1.5vh', right: '20px' }} />

      <Suspense fallback={<LCRouteLoader />}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path={ePublicRoutes.LOGIN} element={<Login />} />
          {/* SupportLogin route removed */}
          <Route path={ePublicRoutes.VERIFY_EMAIL} element={<VerifyEmail />} />
          <Route path={ePublicRoutes.RESET_PASSWORD} element={<ResetPassword />} />
          <Route path={ePublicRoutes.SET_NEW_PASSWORD} element={<SetNewPassword />} />
          <Route path={ePublicRoutes.TRIAL_REGISTRATION_EMAIL} element={<RegisterCompanyEmailPage />} />
          <Route path={ePublicRoutes.TRIAL_REGISTRATION_COMPANY} element={<RegisterCompanyDetailsPage />} />
          <Route path={ePublicRoutes.ACCESSIBILITY} element={<AccessibilityPage />} />
          <Route path={ePublicRoutes.STATUS} element={<PublicStatusPage />} />
          <Route path={ePublicRoutes.LOGIN_MFA} element={<LoginMfa />} />
          <Route path={ePublicRoutes.CHANGE_EXPIRED_PASSWORD} element={<ChangeExpiredPassword />} />
          <Route path={ePublicRoutes.SSO_CALLBACK} element={<SsoCallback />} />
          <Route path={ePublicRoutes.REMOTE_SUPPORT_ESTABLISH} element={<RemoteSupportEstablish />} />
          <Route path="/*" element={<Page404 />} />
        </Routes>
      </Suspense>
    </div>
  )
}
